
import { useSelector } from 'react-redux';

import { getApp } from '../reducers';
import { getArticles } from '../reducers/app';

export default function useArticlesState() {
    return useSelector(state => getArticles(getApp(state)));
}
